/**
 *
 * PassControlSelection
 *
 */

import React, { memo, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// icons
import CustomIcons from 'components/CustomIcons';
// utils
import { getExcusedAbsenceStudents } from 'utils/helpers/helper.generateData';
import { getObjId } from 'utils/helpers/helper.general';

function PassControlSelection({
  // states
  formData,
  course,
  absences,
  attendances,
  currentStep,
  // actoins
  goToStep,
  changeControlType,
  result,
  // default props
  className,
}) {
  const childClassNames = classNames('pass-control-selection', className);
  const { t, i18n } = useTranslation();

  const checkAllStd = useCallback(() => {
    changeControlType('all');
    const originalAbs = absences?.filter(a => a?.status != "refused") || [];
    const absStd = getExcusedAbsenceStudents(
      course?.students,
      originalAbs
    );
    const allStd = course?.students.filter(
      std => !absStd.find(missStd => getObjId(missStd) == getObjId(std)),
    );
    result({
      missing_students: absStd || [],
      students: allStd || [],
    });
    goToStep(currentStep + 2);
  }, [currentStep, course,  course?.students, formData?.date, changeControlType, result, absences]);

  const checkAbsentStd = useCallback(() => {
    changeControlType('check-absent');
    goToStep(currentStep + 1);
  }, [currentStep]);

  const checkPresentStd = useCallback(() => {
    changeControlType('check-present');
    goToStep(currentStep + 1);
  }, [currentStep]);

  const renderCheckAll = useMemo(() => (
    <div className="presences-actions" onClick={checkAllStd}>
      <span className="presences-actions-icon">
        <CustomIcons type="absence-checked" />
      </span>
      <span className="presences-actions-title">
        {t("attendances.attendanceCheckAll")}
      </span>
      <span className="presences-actions-arrow">
        <CustomIcons type="arrow-right" />
      </span>
    </div>
  ), [checkAllStd, i18n?.language]);
  const renderCheckAbsent = useMemo(() => (
    <div className="presences-actions" onClick={checkAbsentStd}>
      <span className="presences-actions-icon">
        <CustomIcons type="check-absent" />
      </span>
      <span className="presences-actions-title">
        {t("attendances.attendanceCheckAbsent")}
      </span>
      <span className="presences-actions-arrow">
        <CustomIcons type="arrow-right" />
      </span>
    </div>
  ), [checkAbsentStd, i18n?.language]);
  const renderCheckPresent = useMemo(() => (
    <div className="presences-actions" onClick={checkPresentStd}>
      <span className="presences-actions-icon">
        <CustomIcons type="check-present" />
      </span>
      <span className="presences-actions-title">
        {t("attendances.attendanceCheckPresent")}
      </span>
      <span className="presences-actions-arrow">
        <CustomIcons type="arrow-right" />
      </span>
    </div>
  ), [checkPresentStd, i18n?.language]);

  return (
    <div className={childClassNames}>
      {renderCheckAll}
      {renderCheckAbsent}
      {renderCheckPresent}
    </div>
  );
}

PassControlSelection.defaultProps = {};
PassControlSelection.propTypes = {
  formData: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
};

export default memo(PassControlSelection);
